import type { Stories, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_STORIES_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllMarketingStoriesQuery {
  allMarketingStories: {
    edges: Stories[]
    pageInfo: PageInfo
  }
}
export interface AllMarketingStoriesQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_MARKETING_STORIES = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allMarketingStories(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_STORIES_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllMarketingStories = (
  variables: AllMarketingStoriesQueryVariables
) =>
  useQuery<AllMarketingStoriesQuery, AllMarketingStoriesQueryVariables>(
    GQL_QUERY_ALL_MARKETING_STORIES,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
